<template>
<div class="page_historyDetail page_adriftDetail">
    <div class="info">
		<div class="info_t">
			<div class="info_t_l" v-if="info">
				<img :src="info.userthumb ? ($publicData.withHttpStart(info.userthumb) ? info.userthumb : imageUrl+info.userthumb) : $publicData.defaultTouxiang" alt="" class="thumb">
				<div class="name">{{info.username}}</div>
			</div>
			<div class="info_t_r" v-if="is_user">
				<div class="action" v-if="info && info.status == 0" @click="toEdit">编辑</div>
				<div class="action" v-if="info" @click="delFun">删除</div>
			</div>
			<div class="info_t_r" v-if="is_user == null && info">{{ info.push_at ? info.push_at : info.created_at}}</div>
		</div>
		<div class="images" v-if="info && info.imagesArr">
            <van-swipe :loop="false">
                <van-swipe-item class="image" v-for="(images,index) in info.imagesArr" :key="index" @click="zhanshitupian(info.imagesArr,index)">
                    <van-image fit="cover" :show-error="false" :show-loading="false" :src="imageUrl+images" class="tu" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="title" v-if="info">{{ info.title }}</div>
        <div class="jieshao" v-if="info">{{ info.content }}</div>
		<!-- 音频 -->
		<div class="yinpin" v-if="info && info.audio_url">
			<audio class="audio" :src="imageUrl+info.audio_url" controls="controls"></audio>
		</div>
		<!-- 位置 -->
		<div class="title location" v-if="info.city_name || info.landmark">
			<van-icon name="location-o" />
			<div class="slh_s">
				<span class="">{{ info.city_name }}</span>
				<span class="" v-if="info.city_name && info.landmark">·</span>
				<span class="">{{ info.landmark }}</span>
			</div>
		</div>
    </div>
	<!-- 评论区域 -->
	<div class="page_iteminfo" v-if="info && info.status == 1 && comments.length!=0">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getData">
			<div class="comment">
				<div class="con" v-for="(comment,index) in comments" :key="index" >
					<div class="con_top clearfix">
						<div class="f-l thumb">
							<img :src="comment.userthumb ? ( $publicData.withHttpStart(comment.userthumb) ?comment.userthumb : imageUrl+comment.userthumb) : $publicData.defaultTouxiang" alt="" class="thumb" />
						</div>
						<div class="f-l con_top_r">
							<span class="user_name">{{ $publicData.formatPhone(comment.username) }}</span>
							<span class="time">{{ comment.created_at }}</span>
						</div>
					</div>
					<div class="con_nr">
						<div class="yiji_txt">{{ comment.comment }}</div>
					</div>
				</div>
			</div>
		</van-list>
	</div>
    <!-- 发评论 点赞 -->
    <div class="bottom" v-if="info && info.status == 1">
        <!-- 发评论 -->
        <div class="comment">
            <div class="comment_l">
                <van-field :border="false" v-model="comment_text" placeholder="说点什么吧～" />
            </div>
            <!-- <div class="comment_r" @click="sendComment">发送</div> -->
        </div>
        <div class="icons">
			<div class="icon" @click="sendComment">
                <img :src=" publicPath+'statics/images/icon_fly.png'" alt="">
            </div>
            <!-- 点赞 -->
            <div class="icon like" @click="likeFun">
                <img :src="info.is_like ? publicPath+'statics/images/icon_liked_red.png' : publicPath+'statics/images/icon_like.png'" alt="">
                <div :class="info.is_like ? 'nums liked' : 'nums'">{{ info.like_nums }}</div>
            </div>
        </div>
    </div>
	<!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from '../../../.././router'
import {
    LOGOUT,
    LOGIN
} from '../../../.././vuex/mutation_types'
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: 'tohistory-index',
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
			comment_text: null,
			drift_id: this.$route.query.drift_id,
			info: null, // 详情信息
			comments: [], // 评论列表
			is_user: this.$route.query.is_user, // 1 是 0 否, 用户是否可进行编辑、删除操作
			loading: true,
			finished: false,
			pages: {
				page: 1,
				size: 10
			},
			bigTuShow: false,
			bigTuIndex: 0,
			bigTuImgArr: null,
			shareConfig: null, // 分享的相关配置
        }
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
		var that = this
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    'naviTitle': '书写记忆让爱漂流',
					'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                (data) => {
                    if (data.code == 200) {
						this.token = data.result.token;
						this.getData()
                    } else {
						this.token = "";
						this.getData()
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('');
                }
            );
			//注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.title ? that.info.title : that.$publicData.shareDefaultTitleA,
                        detail: that.info.content ? that.info.content : '',
                        url: url,
                        platFormType: '',
                        image: that.info.imagesArr ? that.$publicData.domain + that.info.imagesArr[0] : that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
			this.token = this.$store.getters.token;
			this.getData()
        }
		
    },
    methods: {
		// 获取详情信息
		getData(){
			var params = {
				token: this.token,
				drift_id: this.drift_id,
				page: this.pages.page,
				size: this.pages.size
			}
			this.$api.history.lovedriftInfo(params).then(res=>{
				if(res.code == 200){
					var info = res.result
					var list = res.result.comment
					if(info.images){
						info.imagesArr = info.images.split(',')
					}
					// 详情信息
					this.info = info
					// 评论列表
					if(list && list.length != 0){
						for(var i in list){
							this.comments.push(list[i])
						}
						
					}else{
						this.finished = true
					}
					this.loading = false
					this.pages.page ++
					console.log('this.info',this.info)
					// 调起 获取微信分享参数函数
                    this.getShareData()
				}else{
					this.finished = true
				}
			})
		},
		// 编辑
		toEdit(){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = this.$publicData.clientUrl + "/adrift/publish?drift_id="+this.info.id
                var memberParams = {
                    data: {
                    },
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                data: {
                                    url: url
                                },
                            };
                            this.$bridge.callhandler(
                                "sdjy://public/openNewWebView",
                                params,
                                (data) => {}
                            );
                        } 
                    }
                );
                
            } else {
                this.$router.push({
					path: '/adrift/publish',
					query: {
						drift_id: this.info.id
					}
				})
            }
			
		},
		// 评论
		sendComment(){
			if(!this.comment_text){
				this.$toast('请输入评论内容')
				return;
			}
			var params = {
				token: this.token,
				content: this.comment_text,
				drift_id: this.info.id,
				type: 1 // 1评论 2回复评论
			}
			this.$api.history.lovedriftComment(params).then(res=>{
				if(res.code == 200){
					this.$toast('评论成功')
					this.comment_text = ''
					this.comments = []
					this.pages.page = 1
					this.finished = false
					this.loading = true
					this.getData()
				}
			})
		},
		// 点赞
		likeFun(){
			var is_like = this.info.is_like
			var params = {
				token: this.token,
				drift_id: this.info.id
			}
			this.$api.history.lovedriftLike(params).then(res=>{
				if(res.code == 200){
					if(is_like == 0){
						this.$toast('点赞成功')
						this.info.is_like = 1
						this.info.like_nums ++;
					}else{
						this.$toast('取消点赞')
						this.info.is_like = 0
						this.info.like_nums --;
					}
				}
			})
		},
		// 删除
		delFun(){
			var params = {
				token: this.token,
				drift_id: this.info.id
			}
			this.$api.history.lovedriftDel(params).then(res=>{
				if(res.code == 200){
					this.$toast('删除成功')
					this.$router.back()
				}
			})
		},
		// 展开大图 
		zhanshitupian(arr, index) {
			for(let i in arr){
				arr[i] = this.imageUrl+arr[i];
			};
			this.bigTuImgArr = arr;
			this.bigTuIndex = index;
			this.bigTuShow = true;
        },
		// 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
		},
		// 分享
		shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.title ? that.info.title : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.content ? that.info.content : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.imagesArr ? that.imageUrl + that.info.imagesArr[0] : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-cell {
    padding: 0 .2rem;
    background: transparent;
    color: rgba(0, 0, 0, .54);
    font-size: 0.35rem;
    line-height: normal;
}

/deep/.van-cell .van-field__control {
    color: rgba(0, 0, 0, .54);
    font-size: 0.35rem;
}
</style>
